import React, { useEffect } from "react";
import { Menu, Button, Grid, Typography, Slider } from "@material-ui/core";
import { HuePicker, TwitterPicker } from "react-color";
import { setHueHSL, setSaturationHSL, setLightnessnHSL } from "./helper";
import { useTheme } from "../contexts/ThemeContext";

var style = getComputedStyle(document.body);
let root = document.documentElement;

const vars = [
  "--sidebar-color",
  "--bg-color",
  "--stroke-color",
  "--stroke-light-color",
  "--stroke-lighter-color",
  "--fill-color",
  "--input-color",
];

const vars_light = [
  { var: "--sidebar-color", off: 2 },
  { var: "--bg-color", off: 0 },
  { var: "--stroke-color", off: 6 },
  { var: "--stroke-light-color", off: 8 },
  { var: "--stroke-lighter-color", off: 10 },
  { var: "--fill-color", off: 4 },
  { var: "--input-color", off: 4 },
];

const ColorPicker = ({ handleClose, open, anchorEl }) => {
  const {
    color,
    setColor,
    lightness,
    setLightness,
    btncolor,
    setBtnColor,
    saturation,
    setSaturation,
    copied,
    setCopied,
  } = useTheme();

  useEffect(() => {
    if (color.background && btncolor.background) {
      handleHueChange({ hsl: color.background });
      handleBtnColorChange({ hex: btncolor.background });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // when the component is mounted, the alert is displayed for 3 seconds
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  }, [copied, setCopied]);

  const handleHueChange = (color) => {
    vars.forEach((vari) => {
      const hue = style.getPropertyValue(vari);
      const updated = setHueHSL(hue, color.hsl.h);
      console.log(updated);
      root.style.setProperty(vari, updated);
    });
    setColor(color.hsl);
  };

  const handleBtnColorChange = (color) => {
    root.style.setProperty("--primary-color", color.hex);
    setBtnColor({ background: color.hex });
  };

  function changeSaturation(value) {
    setSaturation(value);
    vars.forEach((vari) => {
      const hue = style.getPropertyValue(vari);
      console.log(hue);
      const updated = setSaturationHSL(hue, value);
      console.log(updated);
      root.style.setProperty(vari, updated);
    });
  }

  function changeLightness(value) {
    setLightness(value);
    vars_light.forEach((vari) => {
      const hue = style.getPropertyValue(vari.var);
      const updated = setLightnessnHSL(hue, vari.off + value);
      console.log(updated);
      root.style.setProperty(vari.var, updated);
    });
  }

  return (
    <Menu
      id="long-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      style={{ height: 500, width: 500 }}
    >
      <Grid container style={{ padding: 10 }} spacing={2}>
        <Grid item xs={12}>
          <Typography>Choose primary color</Typography>
          <TwitterPicker
            onChangeComplete={handleBtnColorChange}
            color={btncolor}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography>Choose background color</Typography>
          <HuePicker color={color} onChange={handleHueChange} />
        </Grid>
        <Grid item xs={12}>
          <Typography>Saturation {saturation}</Typography>
          <Slider
            defaultValue={saturation}
            getAriaValueText={changeSaturation}
            aria-labelledby="discrete-slider"
            valueLabelDisplay="auto"
            min={0}
            max={100}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography>Lightness {lightness}</Typography>
          <Slider
            defaultValue={lightness}
            getAriaValueText={changeLightness}
            aria-labelledby="discrete-slider"
            valueLabelDisplay="auto"
            min={0}
            max={80}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            onClick={() => {
              const style = getComputedStyle(document.body);
              let rootStyles = {};
              vars.forEach((vari) => {
                rootStyles[vari] = style.getPropertyValue(vari);
              });
              rootStyles["--primary-color"] =
                style.getPropertyValue("--primary-color");
              navigator.clipboard.writeText(
                Buffer(JSON.stringify(rootStyles)).toString("base64")
              );
              setCopied(true);
            }}
            variant="outlined"
          >
            {copied ? "Copied to clipboard" : "Click to copy theme"}
          </Button>
        </Grid>
        <Grid item xs={12}></Grid>
      </Grid>
    </Menu>
  );
};

export default ColorPicker;
